import { useState, useEffect } from "react";
import { fetchActivities } from "../services/fetchActivities";
import { addActivity as addActivityService } from "../services/addActivity";
import { updateActivity as updateActivityService } from "../services/updateActivity";
import { showSuccessMessage, showApiError } from "@/lib/toast";

export const useLeadActivities = (leadId, user) => {
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadActivities = async () => {
    if (!leadId) return;
    setLoading(true);
    try {
      const res = await fetchActivities(leadId);
      const data = res?.data || res;
      setActivities(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error("Failed to load activities:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadActivities();
  }, [leadId]);

  const addActivity = async (note, disposition) => {
    try {
      const res = await addActivityService(leadId, { 
        comment: note, 
        disposition,
        contactType: 'none',
        interestLevel: 'none'
      });
      const newActivity = res?.data || res;
      setActivities(prev => [newActivity, ...prev]);
      showSuccessMessage("Activity logged");
      return newActivity;
    } catch (err) {
      showApiError(err);
      throw err;
    }
  };

  const updateActivity = async (activityId, note, disposition) => {
    try {
      const res = await updateActivityService(leadId, activityId, { 
        comment: note, 
        disposition,
        contactType: 'none',
        interestLevel: 'none'
      });
      const updated = res?.data || res;
      setActivities(prev => prev.map(a => a._id === activityId ? updated : a));
      showSuccessMessage("Activity updated");
      return updated;
    } catch (err) {
      showApiError(err);
      throw err;
    }
  };

  return { activities, loading, addActivity, updateActivity, refreshActivities: loadActivities };
};
